import { generateState } from '../builder'

export default {
  adaptationKinds: [],
  ...generateState('getAdaptationKinds'),
}
